import { useCallback } from 'react';
import { ToastPosition } from 'react-toastify';
import { ContactForm, ContactFormConfig } from '../types/ContactForm';
import { validateSteps } from '../helpers/stepValidation';

interface UseFormSaveProps {
    currentForm: ContactForm | null;
    config: ContactFormConfig;
    saveCurrentForm: () => Promise<void>;
    showToast: (position: ToastPosition, type: 'info' | 'success' | 'warning' | 'error' | 'default', message: string) => void;
}

export const useFormSave = ({ currentForm, config, saveCurrentForm, showToast }: UseFormSaveProps) => {
    const saveAllSettings = useCallback(async () => {
        try {
            if (currentForm) {
                const validationResult = validateSteps(config);
                if (!validationResult.isValid) {
                    showToast('top-right', 'error', 'Bitte fügen Sie mindestens ein Feld zu jedem Schritt hinzu, bevor Sie speichern.');
                    return;
                }
                await saveCurrentForm();
            } else {
                showToast('top-right', 'error', 'Kein Formular ausgewählt');
            }
        } catch (error) {
            console.error('Save error:', error);
            showToast('top-right', 'error', 'Fehler beim Speichern der Einstellungen!');
        }
    }, [currentForm, config, saveCurrentForm, showToast]);

    return { saveAllSettings };
};

